import { mapjs } from 'utils/Visor';

declare var CONFIGURATIONS;

export default class ResourcesService {

  static getPrintRequest = (url, layer, title, center, scale, template, flightDate, flightScale, flightName, province, township) => {
    const request = {
      layout: template,
      // eslint-disable-next-line
      outputFilename: 'print_${yyyy-MM-dd_hhmmss}',
      attributes: {
        title: title,
        printDate: new Date().toLocaleDateString('es-ES'),
        flightDate: flightDate,
        flightScale: flightScale,
        flightName: flightName,
        province: province,
        township: township,
        map: {
          dpi: 120,
          projection: mapjs.getProjection().code,
          useAdjustBounds: true,
          center: center,
          scale: parseInt(scale, 10),
          layers: [
            {
              baseURL: url,
              opacity: 1,
              type: 'WMS',
              layers: [CONFIGURATIONS.layer_name],
              imageFormat: 'image/png',
              styles: [''],
              customParams: {
                TRANSPARENT: 'true',
                fotograma: layer,
              },
            },
          ],
        },
      },
    };

    return request;
  }

  static getRevergeGeocoderRequest = (lon, lat) => {
    return `<?xml version='1.0' encoding='UTF-8' standalone='yes'?>
      <wps:Execute service="WPS" version="1.0.0" xmlns:wps="http://www.opengis.net/wps/1.0.0" xmlns:ows="http://www.opengis.net/ows/1.1" xmlns:ogc="http://www.opengis.net/ogc" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.opengis.net/wps/1.0.0 http://schemas.opengis.net/wps/1.0.0/wpsExecute_request.xsd">
        <ows:Identifier>org.cnig.cartociudad.wps.ReverseGeocode</ows:Identifier>
        <wps:DataInputs>
          <wps:Input>
            <ows:Identifier>latitud</ows:Identifier>
            <wps:Data>
              <wps:LiteralData dataType="xs:double">${lat}</wps:LiteralData>
            </wps:Data>
          </wps:Input>
          <wps:Input>
            <ows:Identifier>longitud</ows:Identifier>
            <wps:Data>
              <wps:LiteralData dataType="xs:double">${lon}</wps:LiteralData>
            </wps:Data>
          </wps:Input>
        </wps:DataInputs>
        <wps:ResponseForm>
          <wps:ResponseDocument store="false" lineage="false" status="false">
            <wps:Output asReference="false"
                  schema="http://schemas.opengis.net/gml/3.2.1/feature.xsd"
                  mimeType="text/xml" encoding="UTF-8">
              <ows:Identifier>result</ows:Identifier>
              <ows:Title>result</ows:Title>
              <ows:Abstract>result</ows:Abstract>
            </wps:Output>
          </wps:ResponseDocument>
        </wps:ResponseForm>
      </wps:Execute>`;
  }

}
